export default class HeroWithNavigation {
  constructor() {
    this.$links = document.querySelectorAll('.js-hero-navigation-tab-btn');
    this.$tabs = document.querySelectorAll('.js-hero-navigation-tab');

    this.$links.forEach(link => {
      link.addEventListener('click', (e) => {
        const tab = document.querySelector(`section[data-tab-id="${link.dataset.tabId}"]`);

        this.$links.forEach(_link => {
          if (_link.dataset.tabId === link.dataset.tabId) {
            _link.classList.add('is-active');
          } else {
            _link.classList.remove('is-active');
          }
        });

        this.$tabs.forEach(tab => {
          if (tab.dataset.tabId === link.dataset.tabId) {
            tab.classList.remove('hidden');
          } else {
            tab.classList.add('hidden');
          }
        });
      });
    });
  }
}
